import type { GetMeUserResponse } from "@nlc/shared-types";

import { USER_ROLES } from "@nlc/shared-types";
import { createFileRoute, redirect } from "@tanstack/react-router";

import { ConfidenceCheckerAdminPage } from "@/features/confidence-checker-admin";
import { usePageTitle } from "@/hooks/usePageTitle";

export const Route = createFileRoute(
  "/_auth/_app-shell/admin/confidence-checker",
)({
  beforeLoad: async ({ context }) => {
    const userData = context.queryClient.getQueryData<GetMeUserResponse>([
      "user",
    ]);

    // SuperAdmin only — this page manages a global feature flag, not a
    // per-request/per-project setting, so there's no "owner of this record"
    // fallback like most other role checks in this app.
    if (userData?.user?.roleName !== USER_ROLES.SUPER_ADMIN) {
      throw redirect({ to: "/requests" as string });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  usePageTitle("DCC Admin Settings");

  return <ConfidenceCheckerAdminPage />;
}
